import { HeaderRowStyle } from '../../constants/styles';
import frozenViewsBuilder from './frozenViewsBuilder';
import metadataStylesBuilder from './metadataStylesBuilder';
import merge from 'lodash/merge';

import columnDefsToColumnStyle from '../../utils/columnDefsToColumnStyle';

const buildRowStyles = (metadataLength, headerRowHeight) => {
  const metadataStyles = metadataStylesBuilder(metadataLength);

  const headerStyle = {
    [metadataLength]: headerRowHeight ? { ...HeaderRowStyle, height: headerRowHeight } : HeaderRowStyle,
  };

  const rowStyles = {
    ...metadataStyles,
    ...headerStyle,
  };

  return rowStyles;
};

const gridStyleBuilder = params => {
  const {
    sheetName,
    numberOfRowsToStick,
    numberOfColumnsToStick,
    columnDefinitions,
    sheetMetadataLength,
    descriptionColumnIndex,
    hideDecimals,
    negativeMinus,
    shouldDisplayZero,
    headerRowHeight,
    rowStyles = {},
    cellStyles = [],
    rowsCount,
    createAutoFilter,
  } = params;


  const metadata = {
    sheetName,
    views: frozenViewsBuilder({
      rows: numberOfRowsToStick,
      columns: numberOfColumnsToStick,
    }),
    columnStyles: columnDefsToColumnStyle(
      columnDefinitions,
      descriptionColumnIndex,
      {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      }
    ),
    ...(createAutoFilter ? {
      autoFilter: {
        from: {
          row: sheetMetadataLength + 1, // rows are indexed from 1
          column: 1,
        },
        to: {
          row: sheetMetadataLength + 1 + rowsCount,
          column: columnDefinitions.length,
        },
      },
    } : {}),
    rowStyles: merge(buildRowStyles(sheetMetadataLength, headerRowHeight), rowStyles),
    cellStyles,
  };

  return metadata;
};

export default gridStyleBuilder;
